import API from '../../clients/api'

const fetchPresenters = async () => {
  const route = `presenters?number=1000`
  return API.get(route)
    .then(response => Promise.resolve(response.data.data))
    .catch(error => Promise.reject(error.response.data))
}

// eslint-disable-next-line
export { fetchPresenters }
